import { type ReactNode } from 'react';

interface SecaoFormularioProps {
  titulo: string;
  descricao?: ReactNode;
  children: ReactNode;
  /** Botões (salvar/cancelar) no rodapé da seção. */
  acoes?: ReactNode;
  aoEnviar?: () => void;
}

const ESTILO_SECAO =
  'grid gap-6 border-b border-borda py-6 last:border-b-0 md:grid-cols-[minmax(0,16rem)_1fr]';

/**
 * Bloco de formulário: o "porquê" à esquerda, os campos à direita (empilha no celular). Só vira
 * `<form>` com `aoEnviar`; sem ele é uma `<section>`, para poder conter um formulário próprio
 * (form dentro de form é HTML inválido e quebra o envio — achado no certificado, 14/10/2026).
 */
export function SecaoFormulario({
  titulo,
  descricao,
  children,
  acoes,
  aoEnviar,
}: SecaoFormularioProps) {
  const conteudo = (
    <>
      <div className="grid content-start gap-1">
        <h2 className="text-lg font-semibold">{titulo}</h2>
        {descricao && <p className="text-sm text-texto-suave">{descricao}</p>}
      </div>
      <div className="grid gap-4">
        {children}
        {acoes && <div className="flex justify-end gap-2">{acoes}</div>}
      </div>
    </>
  );
  if (!aoEnviar) return <section className={ESTILO_SECAO}>{conteudo}</section>;
  return (
    <form
      noValidate
      onSubmit={(evento) => {
        evento.preventDefault();
        aoEnviar();
      }}
      className={ESTILO_SECAO}
    >
      {conteudo}
    </form>
  );
}
